var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 6,
    viewBox: "0 0 7 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666667 5.33333C0.483333 5.33333 0.326389 5.26806 0.195833 5.1375C0.0652778 5.00694 0 4.85 0 4.66667V0.666667C0 0.483333 0.0652778 0.326389 0.195833 0.195833C0.326389 0.0652778 0.483333 0 0.666667 0H2.66667L3.33333 0.666667H6C6.18333 0.666667 6.34028 0.731944 6.47083 0.8625C6.60139 0.993056 6.66667 1.15 6.66667 1.33333V4.66667C6.66667 4.85 6.60139 5.00694 6.47083 5.1375C6.34028 5.26806 6.18333 5.33333 6 5.33333H0.666667ZM0.666667 4.66667H6V1.33333H3.05833L2.39167 0.666667H0.666667V4.66667Z",
    fill: "#15182C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.eac3566d10a93251d4826b9d68495e4f.svg";
export { ForwardRef as ReactComponent };